import Icon from 'components/atoms/Icon';
import NullState from 'components/organisms/NullState';
import { DiscoverItemCard } from 'utils/gloo-types';
import DiscoverListPreview from 'pages/_AdminAuthoringPages/AdminAuthoringHome/DiscoverListPreview';
import { useDiscoverItemAuthorSelect } from 'utils/discover';
import InAppRoutes, { pushProgressive } from 'utils/router';

interface allAuthorItemsHomeProps {
  authorDiscoverItems: DiscoverItemCard[];
  archived?: boolean;
}

const AllAuthorItems = ({ authorDiscoverItems, archived }: allAuthorItemsHomeProps) => {
  const handleCardClick = useDiscoverItemAuthorSelect();
  const onBack = () => {
    pushProgressive(archived ? InAppRoutes.AdminAuthoringArchiveHome : InAppRoutes.AdminAuthoringHome);
  };

  return (
    <div className="flex flex-col gap-2">
      <button
        className="flex flex-row"
        data-durable-id="authoringAllAuthorContent"
        data-intercom-target="authoringAllAuthorContent"
        onClick={onBack}
      >
        <Icon name="arrow-left" className="mr-2" />
        {archived ? 'Archive' : 'Library'}
      </button>
      {!authorDiscoverItems?.length ? (
        <NullState type="discoverSwimlane" />
      ) : (
        <div className="px-4">
          <DiscoverListPreview
            typographyStyleClassName="mt-4 mb-2 ml-2 text-center md:text-left text-blackDark"
            title={authorDiscoverItems[0].metadata.author || 'Gloo'}
            onClick={handleCardClick}
            itemCards={authorDiscoverItems}
          />
        </div>
      )}
    </div>
  );
};

export default AllAuthorItems;
